import type { QueryClient } from '@tanstack/react-query';
import {
  LeadNotificationsUpdatedEventSchema,
  LeadsUpdatedEventSchema,
} from '@magimp/shared-realtime';
import { engagementsKeys, leadsKeys } from '@magimp/shared-hooks';
import { NOTIFICATIONS_LIST_QK } from '../features/notifications/index.js';

export function invalidateLeadCaches(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({ queryKey: engagementsKeys.all });
  void queryClient.invalidateQueries({ queryKey: leadsKeys.all });
}

export function invalidateLeadNotificationCaches(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({ queryKey: NOTIFICATIONS_LIST_QK });
}

/** Content-free Lead events only select REST-backed query prefixes to refetch. */
export function createLeadRealtimeHandlers(queryClient: QueryClient): {
  leadsUpdatedHandler: (raw: unknown) => void;
  leadNotificationsUpdatedHandler: (raw: unknown) => void;
} {
  return {
    leadsUpdatedHandler: (raw: unknown) => {
      if (!LeadsUpdatedEventSchema.safeParse(raw).success) return;
      invalidateLeadCaches(queryClient);
    },
    leadNotificationsUpdatedHandler: (raw: unknown) => {
      if (!LeadNotificationsUpdatedEventSchema.safeParse(raw).success) return;
      invalidateLeadNotificationCaches(queryClient);
    },
  };
}
